/**
 * Stress Gauge Component
 * Displays field stress level with color-coded visualization
 */

const React = require('react');
const PropTypes = require('prop-types');
const { stress_levels_v2 } = require('fieldManager');
require('./StressGauge.css');

/**
 * Gets stress level configuration
 * @param {string} level - 'None' | 'Low' | 'Medium' | 'High'
 * @param {number} value - 0-1 scale
 * @returns {Object}
 */
const getStressConfig = (level, value) => {
  if (!level || level === 'None' || value === null || value === undefined) {
    return {
      color: 'var(--color-grey-71)',
      background: 'var(--color-grey-96)',
      message: 'No stress data',
      percentage: 0,
    };
  }

  // Map level to stress_levels_v2
  let stressKey;
  if (value <= 0.15) {
    stressKey = 'critical';
  } else if (value <= 0.4) {
    stressKey = 'under_irrigation';
  } else {
    stressKey = 'sufficiency_irrigation';
  }

  const config = stress_levels_v2[stressKey];
  return {
    color: config.color,
    background: config.background,
    message: config.message,
    percentage: Math.round(value * 100),
  };
};

/**
 * StressGauge component
 * @param {Object} props
 * @param {string} props.level - Stress level
 * @param {number} props.value - 0-1 scale value
 * @param {string} props.fieldName - Field name for display
 */
const StressGauge = ({ level, value, fieldName }) => {
  const config = getStressConfig(level, value);

  return (
    <div className='stress-gauge'>
      <div className='stress-gauge__header'>
        <span
          className='text-style-short-lables-12-semi-bold'
          style={{ color: 'var(--color-grey-45)' }}
        >
          Stress Level
        </span>
      </div>

      <div className='stress-gauge__container'>
        <div
          className='stress-gauge__circle'
          style={{
            background: `conic-gradient(${config.color} ${config.percentage * 3.6}deg, var(--color-grey-91) 0deg)`,
          }}
        >
          <div className='stress-gauge__inner-circle'>
            <span
              className='text-style-short-lables-16-semi-bold'
              style={{ color: config.color }}
            >
              {config.percentage}%
            </span>
          </div>
        </div>
      </div>

      <div className='stress-gauge__label'>
        <span
          className='text-style-short-lables-14-regular'
          style={{ color: 'var(--color-grey-45)' }}
        >
          {config.message}
        </span>
      </div>
    </div>
  );
};

StressGauge.propTypes = {
  level: PropTypes.oneOf(['None', 'Low', 'Medium', 'High']).isRequired,
  value: PropTypes.number,
  fieldName: PropTypes.string,
};

StressGauge.defaultProps = {
  value: 0,
  fieldName: '',
};

module.exports = StressGauge;
